export default __webpack_public_path__ + "static/media/Neith.7de3d61a.jpg";